(() => {
  const ROOT_SELECTOR = '[data-jj-size-guide]';

  function activatePanel(root, selectedTab, moveFocus = false) {
    const tabs = Array.from(root.querySelectorAll('[data-jj-size-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-jj-size-panel]'));
    const targetId = selectedTab.dataset.jjSizeTab;

    if (!targetId) return;

    tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;

      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-selected', String(isSelected));
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isSelected = panel.dataset.jjSizePanel === targetId;

      panel.hidden = !isSelected;
      panel.classList.toggle('is-active', isSelected);

      if (isSelected) {
        panel.classList.remove('is-entering');

        requestAnimationFrame(() => {
          panel.classList.add('is-entering');
        });
      }
    });

    if (moveFocus) {
      selectedTab.focus();
    }
  }

  function handleKeyboard(root, event, currentTab) {
    const tabs = Array.from(root.querySelectorAll('[data-jj-size-tab]'));
    const currentIndex = tabs.indexOf(currentTab);

    if (currentIndex < 0) return;

    let nextIndex = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % tabs.length;
        break;

      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        break;

      case 'Home':
        nextIndex = 0;
        break;

      case 'End':
        nextIndex = tabs.length - 1;
        break;

      default:
        return;
    }

    event.preventDefault();
    activatePanel(root, tabs[nextIndex], true);
  }

  function initialiseSizeGuide(root) {
    if (!root || root.dataset.jjSizeGuideInitialised === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-jj-size-tab]'));

    if (!tabs.length) return;

    root.dataset.jjSizeGuideInitialised = 'true';

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activatePanel(root, tab);
      });

      tab.addEventListener('keydown', (event) => {
        handleKeyboard(root, event, tab);
      });
    });

    const initialTab =
      root.querySelector('[data-jj-size-tab].is-active') || tabs[0];

    activatePanel(root, initialTab);
  }

  function initialiseAllSizeGuides(container = document) {
    container.querySelectorAll(ROOT_SELECTOR).forEach(initialiseSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAllSizeGuides();
    });
  } else {
    initialiseAllSizeGuides();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllSizeGuides(event.target);
  });
})();